/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { isUpdateRequired } from '@tcp/core/src/utils';
import { SESSIONCONFIG_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { List } from 'immutable';
import BAGPAGE_CONSTANTS from '@tcp/core/src/components/features/CnC/BagPage/BagPage.constants';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { createSelector } from 'reselect';
import { getUserDefaultPickupStore } from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.selectors';
import CARTPAGE_CONSTANTS from '../CartItemTile.constants';
import { DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY } from '../../Checkout/Checkout.constants';

export const getCookieToken = (state) => state.NavigateXHR.getIn(['cookie_token', 'encodedcookie']);

const getState = (state) => state;

const getNonBopisItemIds = (orderItems) => {
  const ids = [];
  orderItems.forEach((item) => {
    const itemType = item.getIn(['productInfo', 'orderType']);
    if (itemType !== CARTPAGE_CONSTANTS.BOPIS) {
      ids.push(item.getIn(['productInfo', 'itemPartNumber']));
    }
  });
  return ids;
};

const getNonBopisItemWithQty = (orderItems) => {
  const items = [];
  orderItems.forEach((item) => {
    const itemType = item.getIn(['productInfo', 'orderType']);
    if (itemType !== CARTPAGE_CONSTANTS.BOPIS) {
      const productId = item.getIn(['productInfo', 'itemPartNumber']);
      const quantity = item.getIn(['itemInfo', 'quantity']);
      items.push({ productId, quantity });
    }
  });
  return items;
};

const hasBopisItems = (orderItems) => {
  const items = [];
  orderItems.forEach((item) => {
    const itemType = item.getIn(['productInfo', 'orderType']);
    if (itemType === CARTPAGE_CONSTANTS.BOPIS) {
      const productId = item.getIn(['productInfo', 'itemPartNumber']);
      const quantity = item.getIn(['itemInfo', 'quantity']);
      items.push({ productId, quantity });
    }
  });
  return items?.length > 0;
};

export const getCartOrderList = createSelector(getState, (state) => {
  // needs to do it with get method.
  return state?.CartPageReducer?.getIn(['orderDetails', 'orderItems']);
});

export const getNonBopisCartProductIds = createSelector(getCartOrderList, (cartItems) => {
  return cartItems ? getNonBopisItemIds(cartItems) : [];
});

export const getNonBopisCartProductIdsWithQty = createSelector(getCartOrderList, (cartItems) => {
  return cartItems ? getNonBopisItemWithQty(cartItems) : [];
});

export const getHasBopisItems = createSelector(getCartOrderList, (cartItems) => {
  return cartItems ? hasBopisItems(cartItems) : false;
});

export const getTotalItemCount = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'totalItems']);
};

export const getEditableProductInfo = (state) => {
  // needs to do it with get method.
  return state?.CartItemTileReducer?.getIn(['editableItemData', 'colorFitsSizesMap']);
};

export const getEditableProductMultiPackInfo = (state) => {
  return state?.CartItemTileReducer?.getIn(['editableItemMultiPackData']);
};

export const getCartOrderDetails = createSelector(getState, (state) => {
  return state?.CartPageReducer?.get('orderDetails');
});

export const getBossState = (state) => {
  return getCartOrderDetails(state).get('bossState') || '';
};

export const getBossCity = (state) => {
  return getCartOrderDetails(state).get('bossCity') || '';
};

export const getBopisState = (state) => {
  return getCartOrderDetails(state).get('bopisState') || '';
};

export const getBopisCity = (state) => {
  return getCartOrderDetails(state).get('bopisCity') || '';
};

export const isBrierleyWorking = (state) => {
  return getCartOrderDetails(state).get('isBrierleyWorking') || false;
};

export const getIsMiniBagOpen = (state) => {
  return state.Header.miniBag;
};

export const getCartOrderId = (state) => {
  return getCartOrderDetails(state).get('orderId');
};

export const getProductName = (product) => {
  return product.getIn(['productInfo', 'name']);
};

export const checkForGiftItem = (product) => {
  return product.getIn(['productInfo', 'isGiftCard']);
};

export const getProductFit = (product) => {
  return product.getIn(['productInfo', 'fit']);
};

export const getProductColor = (product) => {
  return product.getIn(['productInfo', 'color', 'name']) || product.getIn(['productInfo', 'color']);
};

export const getProductFitSize = (product) => {
  return product.getIn(['productInfo', 'colorFitSizeDisplayNames']);
};

export const getProductSize = (product) => {
  return product.getIn(['productInfo', 'size']);
};

export const getProductShipmentId = (product) => {
  return product.getIn(['productInfo', 'shipmentId']);
};

export const getProductOfferPrice = (product) => {
  return product.getIn(['itemInfo', 'offerPrice']);
};

export const getOriginalPrice = (product) => {
  return product.getIn(['itemInfo', 'price']);
};

export const getPriceAfterItemDiscount = (product) => {
  return product.getIn(['itemInfo', 'priceAfterItemDiscount']);
};

export const getProductQty = (product) => {
  return product.getIn(['itemInfo', 'quantity']);
};

export const getPreOrderDate = (product) => {
  return product.getIn(['itemInfo', 'preOrderDate']) || false;
};

export const getVariantPreOrderDate = (product) => {
  return product.getIn(['miscInfo', 'variantPreOrderMap']) || false;
};

export const getIsPreOrderDataVariantLevel = (product) => {
  const variantPreOrder = product.getIn(['miscInfo', 'variantPreOrderMap']);
  return variantPreOrder && Object.keys(variantPreOrder).length > 0
    ? product.getIn(['miscInfo', 'variantPreOrderMap', 'preOrderDate'])
    : false;
};
export const getbundledProductItems = (product) => {
  return product.getIn(['itemInfo', 'bundledProductItems']) || null;
};

export const getProductPoints = (product) => {
  return product.getIn(['itemInfo', 'itemPoints']);
};

export const getProductBrand = (product) => {
  return product.getIn(['productInfo', 'itemBrand']);
};

export const getProductImage = (product) => {
  return product.getIn(['productInfo', 'imagePath']);
};

export const getOrderItemId = (product) => {
  return product.getIn(['itemInfo', 'itemId']);
};

export const getProductPartNumber = (product) => {
  return product.getIn(['productInfo', 'productPartNumber']);
};

export const getProductItemPartNumber = (product) => {
  return product.getIn(['productInfo', 'itemPartNumber']);
};

export const getVariantNumber = (product) => {
  return product.getIn(['productInfo', 'variantNo']);
};
export const getVariant = (product) => {
  return product.getIn(['productInfo', 'variant']);
};
export const getProductBadge = (product) => {
  return product.getIn(['miscInfo', 'badge', 'defaultBadge']);
};

export const getProductStore = (product) => {
  return product.getIn(['miscInfo', 'store']);
};

export const getProductStoreItemCount = (product) => {
  return product.getIn(['miscInfo', 'storeItemCount']);
};

export const getProductStoreAddress = (product) => {
  return product.getIn(['miscInfo', 'storeAddress']);
};

export const getProductOrderItemType = (product) => {
  return product?.getIn(['miscInfo', 'orderItemType']);
};

export const getBossStartDate = (product) => {
  return product.getIn(['miscInfo', 'bossStartDate']);
};

export const getBossEndDate = (product) => {
  return product.getIn(['miscInfo', 'bossEndDate']);
};

export const getProductAvailability = (product) => {
  return product.getIn(['miscInfo', 'availability']);
};
export const getProductAvailabilitySTH = (product) => {
  return product.getIn(['miscInfo', 'availabilitySTH']);
};

export const getProductavailabileQty = (product) => {
  return product.getIn(['miscInfo', 'availableQty']);
};

export const getIsBossEligible = (product) => {
  return product.getIn(['miscInfo', 'isBossEligible']);
};

export const getIsBopisEligible = (product) => {
  return product.getIn(['miscInfo', 'isBopisEligible']);
};

export const getIsOnlineOnly = (product) => {
  return product.getIn(['miscInfo', 'isOnlineOnly']);
};

export const getClearanceItem = (product) => {
  return product.getIn(['miscInfo', 'clearanceItem']);
};
export const getClearanceTag = (product) => {
  return product.getIn(['miscInfo', 'TCPProductIndStore']);
};
export const getIsHardMarkDownPrice = (product) => {
  return product.getIn(['miscInfo', 'isHardMarkEnabled']);
};

export const getShippingRestrictedStates = (product) => {
  return product.getIn(['miscInfo', 'shippingRestrictedStates']);
};

export const getPromoMessage = (product) => {
  return product.getIn(['miscInfo', 'promoMessage']);
};

export const getAvailableOffers = (product) => {
  return product.getIn(['miscInfo', 'availableOffers']) || [];
};

export const getAppliedOffers = (product) => {
  return product.getIn(['miscInfo', 'appliedOffers']) || [];
};

export const getStoreSpecials = (product) => {
  return product.getIn(['miscInfo', 'storeSpecials']) || undefined;
};

export const getIsPackAndHold = (product) => {
  return product.getIn(['miscInfo', 'isPackAndHold']) || false;
};

export const getStoreHours = (product) => {
  return product.getIn(['miscInfo', 'storeHours']);
};

export const gettcpPromotions = (product) => {
  const promotionsJSON = product.getIn(['miscInfo', 'tcpPromotions']);
  const correctedJsonString = promotionsJSON?.replace(/'/g, '"');
  return correctedJsonString ? JSON.parse(correctedJsonString) : '';
};

export const getIsInventoryAvailBOSS = (product) => {
  return product.getIn(['miscInfo', 'isInventoryAvailBOSS']);
};

export const getInventoryAvailBOSS = (product) => {
  return product.getIn(['miscInfo', 'inventoryAvailBOSS']);
};

export const getInventoryAvailBOPIS = (product) => {
  return product.getIn(['miscInfo', 'inventoryAvailBOPIS']);
};

export const getInventoryAvailSFL = (product) => {
  return product.getIn(['miscInfo', 'sflAvailInventory']);
};

export const getinventoryAvailECOM = (product) => {
  return product.getIn(['miscInfo', 'inventoryAvail']);
};

export const getIsStoreBOSSEligible = (product) => {
  return product.getIn(['miscInfo', 'isStoreBOSSEligible']);
};

export const getStoreTodayOpenRange = (product) => {
  return product.getIn(['miscInfo', 'storeTodayOpenRange']);
};

export const getAccessories = (product) => {
  return product.getIn(['miscInfo', 'c_accessories']);
};

export const getCustomizationType = (product) => {
  return product.getIn(['miscInfo', 'c_customizationType']);
};

export const getShouldBeNestedWithParent = (product) => {
  return product.getIn(['miscInfo', 'shouldBeNestedWithParent']);
};

export const getPriceAdjustments = (product) => {
  return product.getIn(['miscInfo', 'priceAdjustments']);
};

export const getIsMultiPack = (product) => product.getIn(['productInfo', 'multiPack']);

export const getMultiPackItems = (product) => product.getIn(['productInfo', 'multiPackItems']);

export const getMultiPackSKUs = (product) => product.getIn(['productInfo', 'multiPackSKUs']);

export const getTcpStyleQty = (product) => product.getIn(['productInfo', 'tcpStyleQty']);
export const getTcpStyleType = (product) => product.getIn(['productInfo', 'tcpStyleType']);
export const getTcpStyleTypeOriginal = (product) =>
  product.getIn(['productInfo', 'tcpStyleTypeOriginal']);

export const getStoreTomorrowOpenRange = (product) => {
  return product.getIn(['miscInfo', 'storeTomorrowOpenRange']);
};

export const getStorePhoneNumber = (product) => product.getIn(['miscInfo', 'storePhoneNumber']);

export const getVendorColorDisplayId = (product) => {
  return product.getIn(['miscInfo', 'vendorColorDisplayId']);
};

export const getProductItemUpcNumber = (product) => {
  return product.getIn(['productInfo', 'upc']);
};

export const getGeneralProdId = (product) => {
  return product.getIn(['productInfo', 'generalProductId']);
};

export const getProductSkuId = (product) => {
  return product.getIn(['productInfo', 'skuId']);
};

export const getPdpUrl = (product) => {
  return product.getIn(['productInfo', 'pdpUrl']);
};

export const getMultiPack = (product) => {
  return product.getIn(['productInfo', 'multiPack']);
};

export const getSeoToken = (product) => {
  return product.getIn(['productInfo', 'seoToken']);
};

export const getProductItemId = (product) => {
  return product.getIn(['itemInfo', 'itemId']);
};

export const getListPrice = (product) => {
  return product.getIn(['itemInfo', 'listPrice']);
};

export const getOfferPrice = (product) => {
  return product.getIn(['itemInfo', 'offerPrice']);
};

export const getWasPrice = (product) => {
  return product.getIn(['itemInfo', 'wasPrice']);
};

export const getSalePrice = (product) => {
  return product.getIn(['itemInfo', 'salePrice']);
};

export const getIsBossEligibleTile = (product) => {
  return product.getIn(['miscInfo', 'isBossTileEligible']);
};

export const getIsProductOnline = (product) => {
  return product.getIn(['miscInfo', 'online']);
};

export const getProductItemField = (product, objectName, fieldName) => {
  return product.getIn([objectName, fieldName]);
};

// export const getProductItemUnitOfferPrice = product => {
//   return product.getIn(['itemInfo', 'unitOfferPrice']);
// };

// export const getProductItemPrice = product => {
//   return product.getIn(['itemInfo', 'listPrice']);
// };

// export const getProductItemUnitPrice = product => {
//   return product.getIn(['itemInfo', 'listUnitPrice']);
// };

export const getIsCartItemsUpdating = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isCartItemsUpdating']);
};

export const getIsCartItemsSFL = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isItemMovedToSflList']);
};

export const getIsSflItemRemoved = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isSflItemDeleted']);
};

export const getIsBagItemRemoved = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isBagItemDeleted']);
};

export const getIsSflItemMovedToBag = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'isSflItemMovedToBag']);
};

export const getCartItemsSflError = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'cartItemSflError']);
};

export const getMprPointsMultiplier = (product) => {
  return product.getIn(['miscInfo', 'itemMprPointsMultiplier']);
};

export const getPlccPointsMultiplier = (product) => {
  return product.getIn(['miscInfo', 'itemPlccPointsMultiplier']);
};

export const getZipCodeTaxError = (state) => {
  return state.CartPageReducer.getIn(['uiFlags', 'zipCodeError']);
};

export const getUpdateMiniBagFlag = (state) => {
  const isUpdateMiniBag = state.CartPageReducer.getIn(['uiFlags', 'updateMiniBag']);
  if (!isUpdateMiniBag) {
    // Xapp config minibag getOrderDetails timeout in minutes
    const minibagCacheTimeout =
      (state.session &&
        state.session.siteDetails &&
        state.session.siteDetails.MINIBAG_UPDATE_TIMEOUT) ||
      10;
    const lastUpdatedTimestamp = getLocalStorage(BAGPAGE_CONSTANTS.UPDATE_MINIBAG_TIMESTAMP);
    return isUpdateRequired(lastUpdatedTimestamp, minibagCacheTimeout);
  }
  return isUpdateMiniBag;
};

export const getPageName = (state) => {
  const { pageData = {} } = state;
  return pageData.pageName || '';
};

export const getTCPLicensedProductBrand = (product) => {
  return product.getIn(['miscInfo', 'tcpBigIdeaLicensedProductBrand']);
};

export const getEarlyAccessAvailability = (product) => {
  return product.getIn(['miscInfo', 'earlyAccessAvailability']);
};

export const getProductDetails = (tile) => {
  const isPackAndHold = getIsPackAndHold(tile) === true;
  const storeSpecials =
    getStoreSpecials(tile) !== undefined ? getStoreSpecials(tile) === true : undefined;

  return {
    itemInfo: {
      name: getProductName(tile),
      isGiftItem: checkForGiftItem(tile),
      isGiftCard: checkForGiftItem(tile),
      fit: getProductFit(tile),
      color: getProductColor(tile),
      colorFitSizeDisplayNames: getProductFitSize(tile),
      size: getProductSize(tile),
      price: getProductOfferPrice(tile),
      originalPrice: getOriginalPrice(tile),
      priceAfterItemDiscount: getPriceAfterItemDiscount(tile),
      qty: getProductQty(tile),
      myPlacePoints: getProductPoints(tile),
      itemBrand: getProductBrand(tile),
      imagePath: getProductImage(tile),
      itemId: getOrderItemId(tile),
      listPrice: getListPrice(tile),
      offerPrice: getOfferPrice(tile),
      wasPrice: getWasPrice(tile),
      salePrice: getSalePrice(tile),
      itemUnitDstPrice: getProductItemField(tile, 'itemInfo', 'itemUnitDstPrice'),
      itemUnitPrice: getProductItemField(tile, 'itemInfo', 'itemUnitPrice'),
      preOrderDate: getPreOrderDate(tile),
      bundledProductItems: getbundledProductItems(tile),
      // itemPrice: getProductItemPrice(tile),
      // unitOfferPrice: getProductItemUnitOfferPrice(tile),
      // itemUnitPrice: getProductItemUnitPrice(tile),
    },
    productInfo: {
      productPartNumber: getProductPartNumber(tile),
      itemPartNumber: getProductItemPartNumber(tile),
      variantNo: getVariantNumber(tile),
      upc: getProductItemUpcNumber(tile),
      generalProductId: getGeneralProdId(tile),
      skuId: getProductSkuId(tile),
      pdpUrl: getPdpUrl(tile),
      multiPack: getIsMultiPack(tile),
      multiPackItems: getMultiPackItems(tile),
      tcpStyleQty: getTcpStyleQty(tile),
      tcpStyleType: getTcpStyleType(tile),
      variant: getVariant(tile),
      tcpStyleTypeOriginal: getTcpStyleTypeOriginal(tile),
      seoToken: getSeoToken(tile),
    },
    miscInfo: {
      badge: getProductBadge(tile),
      store: getProductStore(tile),
      storeItemsCount: getProductStoreItemCount(tile),
      storeAddress: getProductStoreAddress(tile),
      orderItemType: getProductOrderItemType(tile),
      bossStartDate: getBossStartDate(tile),
      bossEndDate: getBossEndDate(tile),
      availability: isPackAndHold
        ? CARTPAGE_CONSTANTS.AVAILABILITY.SOLDOUT
        : getProductAvailability(tile),
      availabilitySTH: isPackAndHold
        ? CARTPAGE_CONSTANTS.AVAILABILITY.SOLDOUT
        : getProductAvailabilitySTH(tile),
      isBossEligible: getIsBossEligible(tile),
      isBopisEligible: getIsBopisEligible(tile),
      isOnlineOnly: getIsOnlineOnly(tile),
      clearanceItem: getClearanceItem(tile),
      isInventoryAvailBOSS: getIsInventoryAvailBOSS(tile),
      isStoreBOSSEligible: getIsStoreBOSSEligible(tile),
      storeTodayOpenRange: getStoreTodayOpenRange(tile),
      storeTomorrowOpenRange: getStoreTomorrowOpenRange(tile),
      storePhoneNumber: getStorePhoneNumber(tile),
      vendorColorDisplayId: getVendorColorDisplayId(tile),
      itemMprPointsMultiplier: getMprPointsMultiplier(tile),
      itemPlccPointsMultiplier: getPlccPointsMultiplier(tile),
      inventoryAvailECOM: getinventoryAvailECOM(tile),
      inventoryAvailBOSS: getInventoryAvailBOSS(tile),
      inventoryAvailBOPIS: getInventoryAvailBOPIS(tile),
      sflAvailInventory: getInventoryAvailSFL(tile),
      shipmentId: getProductShipmentId(tile),
      accessories: getAccessories(tile),
      customizationType: getCustomizationType(tile),
      shouldBeNestedWithParent: getShouldBeNestedWithParent(tile),
      priceAdjustments: getPriceAdjustments(tile),
      availabileQty: getProductavailabileQty(tile),
      isBossTileEligible: getIsBossEligibleTile(tile),
      isProductOnline: isPackAndHold ? false : getIsProductOnline(tile),
      variantPreOrderMap: JSON.parse(JSON.stringify(getVariantPreOrderDate(tile))),
      TCPProductIndStore: getClearanceTag(tile),
      isHardMarkPrice: getIsHardMarkDownPrice(tile),
      shippingRestrictedStates: getShippingRestrictedStates(tile),
      promoMessage: getPromoMessage(tile),
      availableOffers: getAvailableOffers(tile),
      appliedOffers: getAppliedOffers(tile),
      storeSpecials,
      isPackAndHold,
      tcpPromotions: gettcpPromotions(tile),
      storeHours: getStoreHours(tile),
      tcpLicensedProductBrand: getTCPLicensedProductBrand(tile),
      earlyAccessAvailability: getEarlyAccessAvailability(tile),
    },
    multiPackSKUs: getMultiPackSKUs(tile),
  };
};

export const getItemInfoDetails = (tile) => {
  return {
    c_prodPartNo: getProductPartNumber(tile),
    c_brand: getProductBrand(tile),
    c_TCPColor: getProductColor(tile),
    c_TCPStyleType: getTcpStyleType(tile),
    c_TCPProductIndStore: getClearanceTag(tile),
    c_TCPimages: getProductImage(tile),
    c_fit: getProductFit(tile) || null,
    c_size: getProductSize(tile),
    c_variant: getVariant(tile),
    productId: getGeneralProdId(tile),
    itemId: getOrderItemId(tile),
    quantity: getProductQty(tile).toString(),
    c_TCPStyleQTY: getTcpStyleQty(tile),
    c_TCPWebOnlyFlagStore: getIsOnlineOnly(tile),
    shipment_id: getProductShipmentId(tile),
    c_list_price: getWasPrice(tile),
    c_multiPack: getMultiPack(tile) || false,
    c_isHardMarkEnabled: getIsHardMarkDownPrice(tile) || false,
  };
};

export const getBossBopisFlags = (state) => {
  return {
    isBOSSEnabled_TCP: state.session.siteDetails.isBOSSEnabled_TCP,
    isBOPISEnabled_TCP: state.session.siteDetails.isBOPISEnabled_TCP,
    isBOPISEnabled_GYM: state.session.siteDetails.isBOPISEnabled_GYM,
    isBOSSEnabled_GYM: state.session.siteDetails.isBOSSEnabled_GYM,
  };
};

export const isItemBossBopisInEligible = (state, { itemBrand, orderItemType } = {}) => {
  const bossBopisFlags = getBossBopisFlags(state);
  const flagName = `is${orderItemType}Enabled_${itemBrand}`;
  return (
    (orderItemType === CARTPAGE_CONSTANTS.BOSS || orderItemType === CARTPAGE_CONSTANTS.BOPIS) &&
    !bossBopisFlags[flagName]
  );
};

export const getCartToggleError = (state) => {
  return state?.CartItemTileReducer?.get('toggleError');
};

export const getCartBossBopisToggleError = (state) => {
  return state?.CartItemTileReducer?.get('toggleBossBopisError');
};

export const getIsDeleteConfirmationModalEnabled = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_DELETE_CONFIRMATION_MODAL_ENABLED === 'TRUE'
  );
};

export const getMultiPackInventoryThreshold = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.MULTIPACK_INVENTORY_THRESHOLD
    ? state[SESSIONCONFIG_REDUCER_KEY].siteDetails.MULTIPACK_INVENTORY_THRESHOLD * 1
    : null;
};

const updateSkuList = (productsData, prodData, orderItemType, newBag) => {
  if (orderItemType === CARTPAGE_CONSTANTS.ECOM || newBag) {
    productsData.push(prodData);
  }
};

const checkEcom = (orderItemType) => {
  return (
    orderItemType === CARTPAGE_CONSTANTS.ECOM ||
    orderItemType === CARTPAGE_CONSTANTS.PURE_ECOM ||
    orderItemType === null
  );
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getEcomSkuParams = (cartOrderItems, newBag) => {
  const productsData = [];

  if (cartOrderItems) {
    cartOrderItems.forEach((tile) => {
      if (!getPreOrderDate(tile)) {
        const productDetail = getProductDetails(tile);
        const {
          itemInfo: { qty, itemId, bundledProductItems },
          productInfo: { itemPartNumber },
          miscInfo: { orderItemType },
        } = productDetail;
        if (
          bundledProductItems &&
          itemPartNumber.includes('_B') &&
          (checkEcom(orderItemType) || newBag)
        ) {
          const bundledItems = JSON.parse(JSON.stringify(bundledProductItems));
          if (bundledItems) {
            bundledItems.forEach((item) => {
              const bundleData = {
                skuId: item?.productId,
                skuQty: qty,
                orderItemId: itemId,
              };
              productsData.push(bundleData);
            });
          }
        } else {
          const prodData = {
            skuId: itemPartNumber,
            skuQty: qty,
            orderItemId: itemId,
          };
          if (checkEcom(orderItemType) || newBag) {
            productsData.push(prodData);
          }
        }
      }
    });
  }
  return productsData;
};

export const orderIncludesPurelyPreOrderItems = (state) => {
  const cartOrderItems = state.CartPageReducer.getIn(['orderDetails', 'orderItems']) || [];
  const preOrderData = [];
  if (cartOrderItems) {
    cartOrderItems.forEach((tile) => {
      if (getPreOrderDate(tile)) {
        preOrderData.push(tile);
      }
    });
  }
  return JSON.parse(JSON.stringify(cartOrderItems)).length === preOrderData.length;
};

export const orderIncludesPreOrderItemsOfItemOrVarientLevel = (state) => {
  const cartOrderItems = state.CartPageReducer.getIn(['orderDetails', 'orderItems']) || [];
  const preOrderData = [];
  if (cartOrderItems) {
    cartOrderItems.forEach((tile) => {
      if (getPreOrderDate(tile) || getIsPreOrderDataVariantLevel(tile)) {
        preOrderData.push(tile);
      }
    });
  }
  return preOrderData.length !== 0;
};

// SFCC-TODO to remove in future if not used any where
export const getOrderItemData = (orderDetail, newBag) => {
  const cartOrderItems = orderDetail?.get('orderItems');
  const productsData = [];

  if (cartOrderItems) {
    cartOrderItems.forEach((tile) => {
      const productDetail = getProductDetails(tile);

      const {
        itemInfo: { qty, itemId },
        productInfo: { itemPartNumber },
        miscInfo: { orderItemType },
        multiPackSKUs,
      } = productDetail;

      if (List.isList(multiPackSKUs) && multiPackSKUs.size > 0) {
        multiPackSKUs.forEach((skuitem) => {
          const mpackPartNumber = skuitem.get('partnumber');
          const mpackQty = skuitem.get('quantity');
          const prodData = {
            skuId: mpackPartNumber,
            skuQty: qty * mpackQty,
            orderItemId: itemId,
            parentSkuId: itemPartNumber,
          };
          updateSkuList(productsData, prodData, orderItemType, newBag);
        });
      } else {
        const prodData = {
          skuId: itemPartNumber,
          skuQty: qty,
          orderItemId: itemId,
        };
        updateSkuList(productsData, prodData, orderItemType, newBag);
      }
    });
  }
  return productsData;
};
const getCheckoutShippingData = (shippingData) => {
  const adrs = shippingData.get('address');
  const mtd = shippingData.get('method');
  const shipping = {};
  if (adrs) {
    shipping.address = {
      firstName: adrs.get('firstName'),
      lastName: adrs.get('lastName'),
      addressLine1: adrs.get('addressLine1'),
      addressLine2: adrs.get('addressLine2'),
      city: adrs.get('city'),
      state: adrs.get('state'),
      zipCode: adrs.get('zipCode').trim(),
      country: adrs.get('country'),
    };
  }
  if (mtd) {
    shipping.method = {
      shippingMethodId: mtd.get('shippingMethodId'),
    };
  }
  shipping.emailAddress = shippingData.get('emailAddress');
  shipping.phoneNumber = shippingData.get('phoneNumber');
  return {
    ...shipping,
  };
};
const getCheckoutBillingData = (billingData) => {
  const adrs = billingData.get('address');
  const bill = billingData.get('billing');
  const billing = {};
  if (adrs) {
    billing.address = {
      firstName: adrs.get('firstName'),
      lastName: adrs.get('lastName'),
      addressLine1: adrs.get('addressLine1'),
      addressLine2: adrs.get('addressLine2'),
      city: adrs.get('city'),
      state: adrs.get('state'),
      zipCode: adrs.get('zipCode').trim(),
      country: adrs.get('country'),
    };
  }
  if (bill) {
    billing.billing = {
      cardNumber: bill.get('cardNumber'),
      cardType: bill.get('cardType'),
      expMonth: bill.get('expMonth'),
      expYear: bill.get('expYear'),
      cvv: bill.get('cvv'),
    };
  }
  return {
    ...billing,
  };
};
export const getOrderCheckoutData = (orderDetail) => {
  const checkoutObj = orderDetail.get('checkout');
  let checkoutData = '';
  let shippingData = {};
  let billingData = {};
  if (checkoutObj) {
    const shipping = checkoutObj.get('shipping');
    const billing = checkoutObj.get('billing');
    if (
      shipping &&
      shipping.getIn(['address', 'addressLine1']) !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.address1
    ) {
      shippingData = getCheckoutShippingData(shipping);
    }
    if (
      billing &&
      billing.getIn(['address', 'addressLine1']) !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.address1
    ) {
      billingData = getCheckoutBillingData(billing);
    }
    checkoutData = {
      giftWrap: {},
      pickUpContact: {},
      pickUpAlternative: {},
      shipping: shippingData,
      shipments: {},
      billing: billingData,
    };
  }
  return checkoutData;
};
const getDefaultData = (orderDetail) => {
  return {
    emailSignUpTCP: orderDetail.get('emailSignUpTCP') || true,
    emailSignUpGYM: orderDetail.get('emailSignUpGYM') || true,
    isShippingOrder: orderDetail.get('isShippingOrder') || false,
    isPickupOrder: orderDetail.get('isPickupOrder') || false,
    isBossOrder: orderDetail.get('isBossOrder') || false,
    isBopisOrder: orderDetail.get('isBopisOrder') || false,
    isECOM: orderDetail.get('isECOM') || false,
    orderType: orderDetail.get('orderType') || 'PURE_ECOM', // since BOSS and BOPIS calculation will come in II phase
    orderId: orderDetail.get('orderId') || '',
  };
};
const getSummaryData = (orderDetail) => {
  return {
    couponItems: orderDetail.get('couponItems') || '',
    totalItems: orderDetail.get('totalItems') || 0,
    savingsTotal: orderDetail.get('savingsTotal') || 0,
    couponsTotal: orderDetail.get('couponsTotal') || 0,
    totalTax: orderDetail.get('totalTax') || 0,
    grandTotal: orderDetail.get('grandTotal') || 0,
    subTotal: orderDetail.get('subTotal') || 0,
    totalOrderSavings: orderDetail.get('totalOrderSavings') || 0,
  };
};
const getLoyaltyData = (orderDetail) => {
  return {
    loyaltyCallEnabled: orderDetail.get('loyaltyCallEnabled') || false,
    loyaltyPointsRequestPayload: {
      isElectiveBonus:
        orderDetail.getIn(['loyaltyPointsRequestPayload', 'isElectiveBonus']) || false,
      orderId: orderDetail.getIn(['loyaltyPointsRequestPayload', 'orderId']) || '',
      orderSubTotal: orderDetail.getIn(['loyaltyPointsRequestPayload', 'orderSubTotal']) || 0,
      orderSubTotalBeforeDiscount:
        orderDetail.getIn(['loyaltyPointsRequestPayload', 'orderSubTotalBeforeDiscount']) || 0,
      orderTotalAfterDiscount:
        orderDetail.getIn(['loyaltyPointsRequestPayload', 'orderTotalAfterDiscount']) || 0,
      orderTotalListPrice:
        orderDetail.getIn(['loyaltyPointsRequestPayload', 'orderTotalListPrice']) || 0,
      orderTotalSaving: orderDetail.getIn(['loyaltyPointsRequestPayload', 'orderTotalSaving']) || 0,
      mprId: orderDetail.getIn(['loyaltyPointsRequestPayload', 'mprId']) || 0,
    },
  };
};
const getShippingData = (orderDetail) => {
  return {
    appliedGiftCards: orderDetail.get('appliedGiftCards') || [],
    giftWrappingTotal: orderDetail.get('giftWrappingTotal') || 0,
    giftCardsTotal: orderDetail.get('giftCardsTotal') || 0,
    shippingTotal: orderDetail.get('shippingTotal') || 0,
    applePayShippingTotal: orderDetail.get('applePayShippingTotal') || 0,
    shipModeId: orderDetail.get('shipModeId') || '',
  };
};
const getPointsData = (orderDetail) => {
  return {
    estimatedRewards: orderDetail.get('estimatedRewards') || 0,
    isBrierleyWorking: orderDetail.get('isBrierleyWorking') || false,
    estimatedAirMiles: orderDetail.get('estimatedAirMiles') || 0,
    rewardsToBeEarned: orderDetail.get('rewardsToBeEarned') || 0,
    earnedReward: orderDetail.get('earnedReward') || 0,
    pointsToNextReward: orderDetail.get('pointsToNextReward') || 0,
    pointsApi: orderDetail.get('pointsApi') || '',
  };
};
export const getOrderDetails = createSelector(getCartOrderDetails, (orderDetail) => {
  const initialCheckoutObj = {
    pickUpContact: {},
    pickUpAlternative: {},
    shipping: {},
    giftWrap: {},
    billing: {},
  };
  return {
    ...getDefaultData(orderDetail),
    ...getSummaryData(orderDetail),
    ...getLoyaltyData(orderDetail),
    ...getShippingData(orderDetail),
    ...getPointsData(orderDetail),
    c_couponMap: orderDetail.get('c_couponMap') || '',
    subTotalWithDiscounts: orderDetail.get('subTotalWithDiscounts') || 0,
    subTotalWithoutGiftCard: orderDetail.get('subTotalWithoutGiftCard') || 0,
    checkout: getOrderCheckoutData(orderDetail) || initialCheckoutObj,
    orderItems: getOrderItemData(orderDetail) || [],
    stores: orderDetail.get('stores') || [],
    shipments: orderDetail.get('shipments') || [],
  };
});

export const getStoreDetails = createSelector(getState, (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'stores']);
});

export const getCartLoadingState = (state) => {
  return state?.CartItemTileReducer?.get('cartLoadingState');
};
export const getAdyenApplePayCartLoadingState = (state) => {
  return state?.CartItemTileReducer?.get('adyenApplePayCartLoadingState');
};

export const getTileLoadingState = (state) => {
  return state?.CartItemTileReducer?.get('tileLoadingState');
};

export const getItemUpdatingState = (state) => {
  return state?.CartItemTileReducer?.get('cartItemUpdating');
};

export const getIsBossSwitchFromCheckout = (state) => {
  return state?.CartItemTileReducer?.get('isBossCartFromSwitch');
};

export const getScrollToTile = (state) => {
  return state?.CartItemTileReducer?.get('scrollToTile');
};
export const getOrderShipments = createSelector(getCartOrderDetails, (orderDetail) => {
  return orderDetail?.get('shipments') || [];
});

export const getStoreLoadingState = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('storeUpatingState')
);

export const getStoreUpadateCompetedState = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('storeUpatedCompletedState')
);

export const getshipmentProductInventory = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('shipmentProductInventory')
);

export const getCheckoutProgress = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('checkoutInProgress')
);
export const getIsBackPackAloneError = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('isBackPackAloneError')
);
export const getIsBackPackOOS = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('isBackPackOOS')
);
export const getSflBackPackCall = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('sflBackPackCall')
);

export const getSocialProofCartMessage = createSelector(getState, (state) =>
  state?.CartItemTileReducer?.get('socialProofCartData')
);

export const getInventoryData = createSelector(
  getUserDefaultPickupStore,
  getOrderShipments,
  (userDefaultStore, orderShipments) => {
    const inventoryItems = [];

    if (!orderShipments || orderShipments.length === 0) {
      return inventoryItems;
    }
    if (orderShipments) {
      orderShipments.forEach((element) => {
        inventoryItems.push({
          shipmentId: element?.shipmentId,
          storeId: userDefaultStore?.basicInfo?.id,
        });
      });
      return inventoryItems;
    }
    return inventoryItems;
  }
);

export const getInventoryPayload = createSelector(
  getUserDefaultPickupStore,
  getNonBopisCartProductIds,
  (userDefaultStore, productIds) => {
    const storeIds = [userDefaultStore?.basicInfo?.id];
    return { productIds, storeIds };
  }
);
